import { toast } from 'react-toastify';

export const useAudioRecording = () => {
  const startRecording = async () => {
    let stream = null;
    try {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      return true;
    } catch (error) {
      console.error('Error starting recording:', error);
      toast.error('Error accessing microphone.');
      return false;
    } finally {
      stream?.getTracks().forEach((track) => track.stop());
    }
  };

  return {
    startRecording,
  };
};
